import { dateFilterOperators } from '../../../../containers/base-filter-bar-container/reference-data-criteria-arguments';

export const shouldShowDatePicker = (operator) => {
  return operator.id === dateFilterOperators.dateOnOrBefore || operator.id === dateFilterOperators.dateOnOrAfter;
};

export const isOperatorCustomDateRange = (operator) => {
  return operator?.id === dateFilterOperators.dateCustomRange;
};

export const shouldShowTwoDatePickers = (operator) => {
  return isOperatorCustomDateRange(operator);
};

export const shouldShowNumberInput = (operator) => {
  const numberInputFilterOperators = new Set([
    dateFilterOperators.dateWithinThePastXDays,
    dateFilterOperators.dateWithinTheNextXDays,
    dateFilterOperators.dateXDaysAgoOrMore,
    dateFilterOperators.dateXDaysAheadOrMore,
  ]);
  return numberInputFilterOperators.has(operator.id);
};
